webpackJsonp([281294858691082],{

/***/ 201:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"appUrl":"https://pipeline.social/m/subscribe/"}}},"layoutContext":{}}

/***/ }),

/***/ 314:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _m = __webpack_require__(329);
	
	var _m2 = _interopRequireDefault(_m);
	
	var _layoutM = __webpack_require__(201);
	
	var _layoutM2 = _interopRequireDefault(_layoutM);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_m2.default, _extends({}, props, _layoutM2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 206:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _mixpanelShape = __webpack_require__(208);
	
	var _mixpanelShape2 = _interopRequireDefault(_mixpanelShape);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MixpanelProvider = function (_Component) {
	    _inherits(MixpanelProvider, _Component);
	
	    function MixpanelProvider(props, context) {
	        _classCallCheck(this, MixpanelProvider);
	
	        var _this = _possibleConstructorReturn(this, (MixpanelProvider.__proto__ || Object.getPrototypeOf(MixpanelProvider)).call(this, props, context));
	
	        _this._mixpanel = props.mixpanel;
	        return _this;
	    }
	
	    _createClass(MixpanelProvider, [{
	        key: 'getChildContext',
	        value: function getChildContext() {
	            return { mixpanel: this._mixpanel };
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var children = this.props.children;
	
	            return _react.Children.only(children);
	        }
	    }]);
	
	    return MixpanelProvider;
	}(_react.Component);
	
	exports.default = MixpanelProvider;
	
	MixpanelProvider.propTypes = {
	    mixpanel: _mixpanelShape2.default.isRequired,
	    children: _propTypes2.default.element.isRequired
	};
	MixpanelProvider.childContextTypes = {
	    mixpanel: _mixpanelShape2.default.isRequired
	};

/***/ }),

/***/ 207:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _MixpanelProvider = __webpack_require__(206);
	
	var _MixpanelProvider2 = _interopRequireDefault(_MixpanelProvider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _MixpanelProvider2.default;

/***/ }),

/***/ 208:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _propTypes2.default.shape({
	    init: _propTypes2.default.func.isRequired,
	    track: _propTypes2.default.func.isRequired
	});

/***/ }),

/***/ 329:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(45);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _rebass = __webpack_require__(3);
	
	var _graphql = __webpack_require__(23);
	
	var _graphql2 = _interopRequireDefault(_graphql);
	
	var _styledComponents = __webpack_require__(2);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _reactMixpanel = __webpack_require__(207);
	
	var _reactMixpanel2 = _interopRequireDefault(_reactMixpanel);
	
	var _gatsbyBrowser = __webpack_require__(149);
	
	var _theme = __webpack_require__(154);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import "./all.scss";
	
	var TemplateWrapper = function (_Component) {
	  _inherits(TemplateWrapper, _Component);
	
	  function TemplateWrapper() {
	    _classCallCheck(this, TemplateWrapper);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  TemplateWrapper.prototype.componentDidMount = function componentDidMount() {
	    if (typeof window !== "undefined") window.PL_disableFacebookSDK = true;
	  };
	
	  TemplateWrapper.prototype.render = function render() {
	    var _props = this.props,
	        children = _props.children,
	        siteMetadata = _props.data.site.siteMetadata;
	
	
	    return _react2.default.createElement(
	      _rebass.Provider,
	      { theme: _theme2.default },
	      _react2.default.createElement(_reactHelmet2.default, { title: "Pipeline" }),
	      _react2.default.createElement(
	        _reactMixpanel2.default,
	        { mixpanel: _gatsbyBrowser.mixpanel },
	        children()
	      )
	    );
	  };
	
	  return TemplateWrapper;
	}(_react.Component);
	
	exports.default = TemplateWrapper;
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ }),

/***/ 154:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	// Default values
	exports.default = {
	  colors: {
	    base: "#343D42",
	    support1: "#3A88BA",
	    support2: "#2E5A77",
	    support3: "#4D5052",
	    support4: "#103046",
	    gray1: "#FAFAFA",
	    gray2: "#EAEAEA",
	    gray3: "#CBCBCB",
	    facebookBlue: "#365899",
	    messengerBlue: "#3A82F7",
	    error: "#da3f51",
	    success: "#00d1b2",
	    info: "#c2e0ff",
	    edit: "#B6B9EF",
	    beige: "#f7f7f5"
	  }
	};
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-m-jsx-a6b90ebd99e31b81a521.js